import { render, staticRenderFns } from "./ProcessedIssues.vue?vue&type=template&id=182fd51e&scoped=true"
import script from "./ProcessedIssues.vue?vue&type=script&lang=js"
export * from "./ProcessedIssues.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182fd51e",
  null
  
)

export default component.exports